var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_5395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8.58333L15.3761 10.25L13.7513 8.58333M15.5747 9.83333C15.6042 9.55972 15.6193 9.28167 15.6193 9C15.6193 4.85786 12.3467 1.5 8.30966 1.5C4.27265 1.5 1 4.85786 1 9C1 13.1421 4.27265 16.5 8.30966 16.5C10.6059 16.5 12.6549 15.4136 13.995 13.7144M8.30966 5.83333V10L10.7462 11.6667",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_5395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionHistory);
export default __webpack_public_path__ + "static/media/version-history.cb2eabfc3010b0aa3ad9ab32904e63e9.svg";
export { ForwardRef as ReactComponent };